<template>
    <div class="login">
        <el-card>
            <!-- <div class="login-title">
              <h2>Login</h2>
            </div> -->
            <el-form
                    :model="model"
                    :rules="rules"
                    class="login-form"
                    ref="form"
                    @submit.native.prevent="login"
            >
                <!-- @submit.native.prevent="login" -->
                <el-form-item prop="username">
                    <el-input v-model="model.username"  placeholder="Username"
                    ></el-input>



                </el-form-item>

                <el-form-item prop="password">
                    <el-input
                            v-model="model.password"
                            placeholder="Password"
                            type="password"
                    ></el-input>
                </el-form-item>




                <el-form-item>
                    <el-button
                            :loading="loading"
                            class="login-button"
                            native-type="submit"
                            block
                    >Login</el-button
                    >
                </el-form-item>


            </el-form>
        </el-card>


    </div>
</template>


<script>
import Axios from 'axios'

export default {
  name: "login",
  data() {
    return {
      formatted_address : '',
      country : '',
      administrative_area_level_1  : '',
      totalData: [],


      validCredentials: {
        username: "admin",
        password: "1234"
      },
      loading: false,
      model: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "Username is required",
            trigger: "blur"
          },
          {
            min: 2,
            message: "Username length should be at least 2 characters",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Password is required",
            trigger: "blur"
          },
          {
            min: 2,
            message: "Password length should be at least 2 characters",
            trigger: "blur"
          }
        ]
      }
    };
  },

  methods: {
    simulateLogin() {
      return new Promise(resolve => {
        setTimeout(resolve, 800);
      });

    },
    newAccount() {
      this.$router.push({ name: 'newAccount' })
    },

    async login() {

      // this.$store.commit("displayChange");
      let valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      }
      this.loading = true;
      const reqJson = { 'user_id': this.model.username.toLowerCase() , 'password': this.model.password.toLowerCase()};
      const config ={
        headers: { 'content-type': 'application/json' },
        withCredentials: true,
      };

      await Axios.post( this.$url + '/UserInfo/logIn', reqJson, config  ).then(res => {
        // console.log(res.data)
        if (res.data.resultCode)
        {
          this.$message.success("Login successfull");
          this.$store.commit("setAccessToken",res.data.accessToken );
          this.$store.commit("setDeptSeq",res.data.dept_seq );
          this.$store.commit("setUserId",res.data.user_id );
          this.$store.commit("setRfid_get_order_seq",res.data.rfid_get_order_seq );

          console.log("address1==================="+res.data.address1+"========================");
          console.log("address2==================="+res.data.rfid_get_order_seq+"========================");


          this.$store.commit("setDeptName",res.data.dept_name );
          this.$store.commit("setAddress1", res.data.address1);
          this.$store.commit("setAddress2", res.data.address2);

          // if (this.model.username.toLowerCase() == 'admin') {
          //     this.allCountryUpdate();
          // }



          this.$router.push({ name: 'leftMenu' })





        }else{
          this.$message.error("Username or password is invalid");
        }

        this.loading = false;
      })
          .catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.loading = false;
          }); // await Axios.post
    },//async login()


    async updateAddress(reqDataJson){

      let url = this.$url + '/authInfo/updateAddress';

      console.log("==============updateAddressupdateAddressupdateAddress================");
      console.log(reqDataJson);


      await Axios.post(url, reqDataJson , this.$store.state.config ).then(res => {
        let saveCount = res.data;
        if (saveCount){
          // this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);

        }else{
          // this.$message.error(this.$store.state.serverErrorMessage);
          // this.currentPage = 1;

        }
      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
            // this.$message.error(this.$store.state.serverErrorMessage);
            // this.currentPage = 1;
            // this.loading = false;
          }); // await Axios.post
    },

    async getaddress(latitude,  longitude, auth_info_seq ) {

      // let url2  = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+resDataJson[resData]['latitude'] +","+ resDataJson[resData]['longitude'] +"&key=AIzaSyA1LUF3e_P4F_vrT24zIJDy9p96eRJQmdg&language=ko"
      // console.log("==============URL URL================");
      // console.log(url2);

      let url2  = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+latitude +","+ longitude +"&key=AIzaSyA1LUF3e_P4F_vrT24zIJDy9p96eRJQmdg&language=ko"
      console.log("==============URL URL================");
      console.log(url2);


      await Axios.get(url2 ).then(res => {

        console.log("==============URL RESULT ================");
        console.log(res.data['results'][0]['formatted_address']);

        this.formatted_address = res.data['results'][0]['formatted_address'] ;

        for(var i=0 ; i< res.data['results'][0]['address_components'].length   ; i++) {
          if (res.data['results'][0]['address_components'][i]['types'][0] == "country")
            this.country= res.data['results'][0]['address_components'][i]['long_name']   ;

          if (res.data['results'][0]['address_components'][i]['types'][0] == "administrative_area_level_1")
            this.administrative_area_level_1 = res.data['results'][0]['address_components'][i]['long_name']  ;
        }

        this.totalData = [];

        this.totalData.push({
            auth_info_seq: auth_info_seq
          , country: this.country
          , administrative_area_level_1: this.administrative_area_level_1
          , formatted_address: this.formatted_address
        });
        console.log("==============totalDatatotalDatatotalData================");
        console.log(this.totalData);
        this.updateAddress(this.totalData);

      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
          }); // await Axios.post

    },

    async  allCountryUpdate(){

      console.log("==============allCountryUpdate================");
      console.log(this.totalData);

      let url = this.$url + '/authInfo/updateList';
      var reqJson = new Object();

      await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
        var resDataJson = res.data.authInfoDTO;


        console.log("==============/authInfo/updateList================");
        console.log(resDataJson);

        this.totalData=[];
        if (res.data.resultCode){

          for (var resData in resDataJson) {
            this.getaddress( resDataJson[resData]['latitude'] , resDataJson[resData]['longitude'], resDataJson[resData]['auth_info_seq']    )
          }

        }else{
          // this.$message.error(this.$store.state.dataNotFound);
          // this.currentPage = 1;
          // this.loading = false;
        }
      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
            // this.$message.error(this.$store.state.serverErrorMessage);
            // this.currentPage = 1;
            // this.loading = false;
          }); // await Axios.post
    }, //allCountryUpdate
  },//methods

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
//.el-select .el-input {
//  width: 410px !important;
//}

$teal: rgb(0, 124, 137);
.login .el-input__inner:hover {
  border-color: $teal;
}
.login .el-input input {
  padding-left: 35px;
}

.el-table {
  font-family: "Segoe UI", "Malgun Gothic";
  font-size: 9px !important;
}

.bg-purple-light {
  background: #f3f5f2;
  border-radius: 0.5rem !important;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

/* // 위에 검색 grid  간격  */
.el-row {
  margin-bottom: 10px;
}

.el-col {
  border-radius: 4px;
}

.el-table th > .cell {
  height: 42px !important;
  display: flex !important;
  align-items: center !important;
}
.el-table .cell {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 30px !important;
  line-height: 30px;
}

.pagination {
  height: 52px !important;
  display: flex !important;
  align-items: center !important;
}

.el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  height: 9px !important;
  display: flex !important;
  align-items: center !important;
  /* // margin-left: 20px !important; */
}

.searchTitle {
  height: 30px !important;
  width: 82px !important;
  font-size: 11px !important;
  align-items: center !important;
  margin-left: 10px !important;
  display: flex !important;
  /* // border: 1px solid #f29659 !important; */
}

.searchBody {
  height: 30px !important;
  font-size: 10px !important;
  align-items: center !important;
  margin-left: 10px !important;
  display: flex !important;
  /* // background-color: #409EFF;
  // border: 1px solid #f29659 !important; */
}

.searchBody_brand {
  width: 50px !important;
  /* // border: 1px solid #f29659 !important; */
}

.searchBody_year {
  width: 50px !important;
  /* // border: 1px solid #f29659 !important; */
  margin-left: 20px !important;
}

.searchBody_season {
  width: 50px !important;
  /* // border: 1px solid #f29659 !important; */
  margin-left: 20px !important;
}

.searchBody_production {
  width: 50px !important;
  /* // border: 1px solid #f29659 !important; */
  margin-left: 20px !important;
}

.el-input--mini .el-input__inner {
  height: 20px !important;
  width: 100px !important;
  border: 1px solid #f29659 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  /* // font-family: Segoe UI,Malgun Gothic !important;
  // font-weight: 400 !important; */
  font-size: 9px !important;
  cursor: pointer !important;
  padding: 0 6px !important;
}

//.el-select .el-input.is-focus .el-input__inner {
//  height: 20px !important;
//  width: 100px !important;
//  border: 1px solid #f29659 !important;
//  border-radius: 4px !important;
//  box-sizing: border-box !important;
//  /* // font-family: Segoe UI,Malgun Gothic !important;
//  // font-weight: 400 !important; */
//  font-size: 9px !important;
//  cursor: pointer !important;
//  padding: 0 6px !important;
//}
.el-select .el-input__inner {
  cursor: pointer;
  height: 20px !important;
  width: 100% !important;
  border: 1px solid #f29659 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  /* // font-family: Segoe UI,Malgun Gothic !important;
  // font-weight: 400 !important; */
  font-size: 9px !important;
  cursor: pointer !important;
  padding: 0 6px !important;
}

.el-select .el-input .el-select__caret {
  color: #f29659;
  width: 20px !important;
  height: 20px !important;
  font-size: 9px !important;
  align-items: center !important;
  margin-left: 0px !important;
  display: flex !important;
}

.el-icon-arrow-up:before {
  margin-left: 3px !important;
  display: flex !important;
}

.el-select-dropdown__item.selected {
  color: #f29659 !important;
  font-size: 9px !important;
  font-weight: 0 !important;
}
::after,
::before {
  font-size: 11px !important;
}



// .el-icon-date:before {
//   height: 22px !important;
//   align-items: center !important;
//   margin-top: 0px !important;
//   margin-left: 0px !important;
//   display: flex !important;
// }

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100px !important;
}

.el-input__icon {
  line-height: 25px !important;
}

.searchBody_barcode {
  width: 80px !important;
  margin-left: 20px !important;
}
</style>
